import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHero } from '../../components/PageHero';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Eye, Award, BookOpen, MapPin, FileText, FolderOpen, ArrowRight } from 'lucide-react';
const sections = [{
  name: 'Президія',
  href: '/federation/presidia',
  icon: <Users className="h-5 w-5" data-id="element-758" />,
  description: 'Керівний орган федерації — президент, віце-президенти та члени президії.'
}, {
  name: 'Наглядова рада',
  href: '/federation/supervisory-board',
  icon: <Eye className="h-5 w-5" data-id="element-759" />,
  description: 'Контролюючий орган, що забезпечує прозорість діяльності федерації.'
}, {
  name: 'Рада ветеранів',
  href: '/federation/veterans-council',
  icon: <Award className="h-5 w-5" data-id="element-760" />,
  description: 'Досвідчені альпіністи та скелелази, які зробили значний внесок у розвиток спорту.'
}, {
  name: 'Комісія з навчання та безпеки',
  href: '/federation/education-commission',
  icon: <BookOpen className="h-5 w-5" data-id="element-761" />,
  description: 'Розробка навчальних програм, методичних рекомендацій та стандартів безпеки.'
}, {
  name: 'Відокремлені підрозділи',
  href: '/federation/subdivisions',
  icon: <MapPin className="h-5 w-5" data-id="element-762" />,
  description: 'Регіональні представництва федерації по всій Україні.'
}, {
  name: 'Рішення президії',
  href: '/federation/decisions',
  icon: <FileText className="h-5 w-5" data-id="element-763" />,
  description: 'Протоколи засідань та офіційні рішення президії ФАіСУ.'
}, {
  name: 'Документи',
  href: '/federation/documents',
  icon: <FolderOpen className="h-5 w-5" data-id="element-764" />,
  description: 'Статутні, нормативні та фінансові документи федерації.'
}];
export function FederationIndex() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-765">
      <Header data-id="element-766" />
      <main className="pt-20" data-id="element-767">
        <PageHero label="Структура" title="Федерація" subtitle="Організаційна структура Федерації Альпінізму і Скелелазіння України — органи управління, комісії та підрозділи." data-id="element-768" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-769">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-770">
            {sections.map((section, index) => <motion.div key={section.href} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} data-id="element-771">
                <Link to={section.href} className="block bg-white rounded-lg border border-gray-200 shadow-sm p-6 group cursor-pointer hover:border-primary/20 hover:shadow-md transition-all" data-id="element-772">
                  <div className="flex items-start gap-4" data-id="element-773">
                    <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0 text-primary group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-774">
                      {section.icon}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-775">
                      <div className="flex items-center justify-between" data-id="element-776">
                        <h3 className="text-sm font-bold text-primary group-hover:text-primary-light transition-colors" data-id="element-777">
                          {section.name}
                        </h3>
                        <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-primary transition-colors flex-shrink-0" data-id="element-778" />
                      </div>
                      <p className="text-gray-500 text-sm mt-1.5 leading-relaxed" data-id="element-779">
                        {section.description}
                      </p>
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-780" />
    </div>;
}